export default __webpack_public_path__ + "static/media/Edge of the Night Spirits.a5de0e34.jpg";